import React from 'react';

import AuthenticationFlow from 'legacy/auth/components/authentication-flow/AuthenticationFlow';
import useAuthenticationStatus from 'legacy/common/hooks/useAuthenticationStatus';

import { useCheckout } from 'features/events/checkout/context';
import { CheckoutSteps, GoToStepFn } from 'features/events/checkout/types';
import Button from 'components/Button';
import { useTranslation } from 'react-i18next';

type Props = {
  goToStep: GoToStepFn;
};

const GoToRequestScreeningButton = ({ goToStep }: Props) => {
  const { t } = useTranslation(['checkout', 'common']);
  const { onAuthenticationSuccess, requestScreening, onSuccess } =
    useCheckout();
  const { isAuthenticated } = useAuthenticationStatus();

  const goToRequestScreening = () => {
    if (requestScreening.questions.length > 0) {
      goToStep(CheckoutSteps.RequestScreening);
    } else {
      requestScreening.submitRequest({}).then(() => {
        onSuccess();
        goToStep(CheckoutSteps.SuccessRequestApproval);
      });
    }
  };

  if (!isAuthenticated()) {
    return (
      <AuthenticationFlow onCompleteAuthentication={onAuthenticationSuccess}>
        {({ startAuthenticationFlow }) => (
          <Button
            variant="primaryDark"
            size="large"
            className="w-full"
            onClick={startAuthenticationFlow}
          >
            {t('common:buttons.continue')}
          </Button>
        )}
      </AuthenticationFlow>
    );
  }

  return (
    <Button
      variant="primaryDark"
      size="large"
      className="w-full"
      onClick={goToRequestScreening}
    >
      {t('checkout:requestToPurchase')}
    </Button>
  );
};

export default GoToRequestScreeningButton;
